import { DEFAULT_STROKE_SCALE_ENABLED } from './constants';
import { BaseStyleProperties } from './types';

const shouldBeStrokeScaleEnabled = (annotation: {
  style?: BaseStyleProperties;
}): boolean =>
  annotation.style?.shouldEnableStrokeScale ?? DEFAULT_STROKE_SCALE_ENABLED;

export default shouldBeStrokeScaleEnabled;
